import { createIcons, Facebook, Linkedin, X as Twitter, Instagram, Globe , ArrowRight, ArrowDown, ChevronDown, FileText, Bookmark, ShoppingBag, Tag, Search, Menu } from 'lucide';
createIcons({ 
    icons:{
        Facebook, Linkedin, Twitter, Instagram, Globe, ArrowRight, ArrowDown, ChevronDown, FileText, Bookmark, ShoppingBag, Search, Menu, Tag
    }
 });